import apiRequest from "@/utils/api";
import { getAuthHeader } from ".";
import {
  TCreateCrateRequest,
  TCreateFundResponse,
  TReadFundDevResponse,
  TDeployCrateResponse,
  TPublicFundData,
  TDeleteFundResponse,
  TDashboardResponse,
} from "@/types/types";

export const getDashboardData = (): Promise<TDashboardResponse[]> => {
  return apiRequest("/v1/user/dashboard", {
    method: "GET",
    headers: getAuthHeader(),
  });
};

export const createCrate = (
  crate: TCreateCrateRequest
): Promise<TCreateFundResponse | { error: string }> => {
  crate.Weights = crate.Weights.map((weight: number) =>
    parseFloat((weight / 100).toFixed(4))
  );
  return apiRequest("/v1/fund/create/crate", {
    method: "POST",
    headers: getAuthHeader(),
    body: JSON.stringify(crate),
  });
};

export const updateCrate = (
  fundID: number,
  crate: TCreateCrateRequest
): Promise<any> => {
  crate.Weights = crate.Weights.map((weight: number) =>
    parseFloat((weight / 100).toFixed(4))
  );
  return apiRequest(`/v1/fund/update/crate/${fundID}`, {
    method: "PUT",
    headers: getAuthHeader(),
    body: JSON.stringify(crate),
  });
};

export const readCreatorFundByID = (
  fundID: number
): Promise<TReadFundDevResponse> => {
  return apiRequest(`/v1/fund/get-fund/dev/${fundID}`, {
    method: "GET",
    headers: getAuthHeader(),
  });
};

export const readFundByID = (fundID: number): Promise<TReadFundDevResponse> => {
  return apiRequest(`/v1/fund/get-fund/user/${fundID}`, {
    method: "GET",
    headers: getAuthHeader(),
  });
};

export const deployFund = (
  fundID: number,
  contractAddress: string
): Promise<TDeployCrateResponse> => {
  return apiRequest(`/v1/fund/deploy/${fundID}`, {
    method: "POST",
    headers: getAuthHeader(),
    body: JSON.stringify({ contractAddress }),
  });
};

export const deleteFund = (fundID: number): Promise<TDeleteFundResponse> => {
  return apiRequest(`/v1/fund/delete/${fundID}`, {
    method: "DELETE",
    headers: getAuthHeader(),
  });
};

export const readFundsForExplore = (): Promise<TPublicFundData[]> => {
  return apiRequest(`/v1/user/explore`, {
    method: "GET",
    headers: getAuthHeader(),
  });
};

// export const deployCitreaFund = (
//   fundID: number,
//   tokenAddresses: string[],
//   priceFeeds: string[],
//   weights: number[]
// ): Promise<TDeployCitreaFundResponse> => {
//   return apiRequest(`/v1/fund/citrea/deploy/${fundID}`, {
//     method: "POST",
//     headers: getAuthHeader(),
//     body: JSON.stringify({ tokenAddresses, priceFeeds, weights }),
//   });
// };

export const checkInviteCode = (
  code: string
): Promise<{ token?: string; error?: string }> => {
  return apiRequest(`/v1/user/check-invite`, {
    method: "POST",
    headers: getAuthHeader(),
    body: JSON.stringify({ invite_code: code }),
  });
};
